/* global axios */
import ApiClient from './ApiClient';

class CouponsAPI extends ApiClient {
  constructor() {
    super('coupons', { accountScoped: true });
  }

 // get all items
 getAllCoupons(params={}) {
  return axios.get(`${this.url}`,{
    params: {
      ...params
    }
  });
 }
 getCouponById(coupon_id) {
  return axios.get(`${this.url}/${coupon_id}`);
 }
 createCoupon(payload) {
   return axios.post(`${this.url}`,payload);
  }
  updateCouponById(coupon_id,payload) {
   return axios.patch(`${this.url}/${coupon_id}`,payload);
  }
  deleteCouponById(coupon_id,) {
   return axios.delete(`${this.url}/${coupon_id}`,);
  }

  getCouponReport(params) {
    // /reports?kind=report_by_volumes&start_date=2025-04-7&end_date=2025-04-14
    return axios.get(`${this.url}/reports`,{
      params: {
        ...params
      }
    });
  }
  getCouponCollectById(coupon_id,params) {
    // /api/v1/accounts/613/coupons/29/collect?contact_id=100484
    return axios.get(`${this.url}/${coupon_id}/collect`,{
      params: {
        ...params
      }
    });
  }

  // apply coupon to get  discount
  applyCoupon(payload){
    return axios.post(`${this.url}/apply_coupon`,payload);
  }

  getCouponTemplateById(coupon_id,params) {
    // /coupons/5/templates?inbox_id=300
    return axios.get(`${this.url}/${coupon_id}/templates`,{
      params: {
        ...params
      }
    });
  }

  getDefaultCoupons(params={}){
    return axios.get(`${this.url}/lists`,{
      params: {
        ...params
      }
    });
  }


}

export default new CouponsAPI();
